enum ActionTypes {
    SAVE_DEALERGROUPS = "SAVE_DEALERGROUPS",
    SET_ACTIVE_DEALERGROUP = "SET_ACTIVE_DEALERGROUP",
    LOADING_DEALERGROUPS = "LOADING_DEALERGROUPS",
    LOADING_DEALERGROUP_MEMBERS = "LOADING_DEALERGROUP_MEMBERS",
    LOGOUT_ACTION = "LOGOUT_ACTION",
}

export default ActionTypes;
